module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAVCAYAAAC6wOViAAABRElEQVRIS73UQU6DQBQG4P+NRk2AZK7g0k3tEdqTtF2Z7ryCJ3CpuAFPYHqCxhvUVtf0CE1KE21SnqFIQ8rAMBRkR4D55j3m/YR/uKyvl67YRW8AyeiM+tS2mYA8BUHGFgPvraLH4B/60BqqAsF4XXfuhq2gZWBcbeOoDmwcrQI2ilYFEzTwpBX+DHbnPPm+GS/rjJAJuEftxfOMQLfxTcTRaNMZ+yawKbhHnYXLWcQEVs8hf4T2ZQ/Xo1XR5smaPw0FCc8UrgseDpL16d4LxmNlOPCks94GabQlSaOvMF3/MKfO3PVBGGjhwJN2uJ0S0E3fNQFzI6OFGwCVc6qCGVE/tK9mp1aYa2+2rTmYsWLC8pSWZtcvzF5VxXX/4fHolAa+utXVT2nhnOrSJwubntLaaPxhHCAQQm6sC78saXQFpM9/AUjN7fBwz8MVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/open.png
// module id = iFAN
// module chunks = 1 12